import 'react-perfect-scrollbar/dist/css/styles.css';
import React from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/components/GlobalStyles';
import theme from 'src/theme';
import routes from 'src/routes';
import { SnackbarProvider } from 'notistack';
import { useMountedLogic } from 'kea';

import alertlogic from './store/alert';
import vehiclelogic from './store/vehicle';
import geofencelogic from './store/geofence';
import grouplogic from './store/group';
import { preferenceslogic, maplogic, replaylogic, infowindowlogic, assetmaplogic } from './store/global';
import organisationlogic from './store/organisation';
import profilelogic from './store/profile';
import {
	ralertlogic, rgeofencelogic, rmovementlogic, rnotificationlogic,
	rstationarylogic, rsummarylogic, rtemperaturelogic, rtrackerslogic
} from './store/report';
import rolelogic from './store/role';
import userlogic from './store/user';
import feedbacklogic from './store/feedback';
import dayjs from 'dayjs';

const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
const relativeTime = require('dayjs/plugin/relativeTime')

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)

const App = () => {
	useMountedLogic(alertlogic);
	useMountedLogic(vehiclelogic);
	useMountedLogic(geofencelogic);
	useMountedLogic(grouplogic);
	useMountedLogic(organisationlogic);
	useMountedLogic(profilelogic);
	useMountedLogic(rolelogic);
	useMountedLogic(userlogic);

	//global logic
	useMountedLogic(preferenceslogic);
	useMountedLogic(maplogic);
	useMountedLogic(assetmaplogic);
	useMountedLogic(replaylogic);
	useMountedLogic(infowindowlogic);

	//report logic
	useMountedLogic(ralertlogic);
	useMountedLogic(rgeofencelogic);
	useMountedLogic(rmovementlogic);
	useMountedLogic(rnotificationlogic);
	useMountedLogic(rstationarylogic);
	useMountedLogic(rsummarylogic);
	useMountedLogic(rtemperaturelogic);
	useMountedLogic(rtrackerslogic);

	//feedback logic
	useMountedLogic(feedbacklogic);

	const routing = useRoutes(routes);

	return (
		<ThemeProvider theme={theme}>
			<GlobalStyles />
			<SnackbarProvider
				maxSnack={3}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}>
				{routing}
			</SnackbarProvider>
		</ThemeProvider>
	);
};

export default App;
